import React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, FormHelp, Grid, Heading, Input, Label } from '@zillow/constellation';

import type { PeopleSection } from '../../../models/index';
import { FULLSTORY_EXCLUDE } from '../../../constants/analytics';
import { EMERGENCY_CONTACT, PERSON } from '../../../constants';
import type { HTMLElementEvent } from '../../../models/Types';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function EmergencyContact({ section, setSectionValues }: Props): JSX.Element {
  function setFirstName(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [EMERGENCY_CONTACT.FIELD_NAME.FIRST_NAME]: event.currentTarget.value,
    });
  }

  function setLastName(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [EMERGENCY_CONTACT.FIELD_NAME.LAST_NAME]: event.currentTarget.value,
    });
  }

  function onPhoneNumberChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [EMERGENCY_CONTACT.FIELD_NAME.PHONE_NUMBER]: value,
    });
  }

  return (
    <>
      <Heading level={6} marginBottom="sm">
        Who should the tenant contact in case there is an emergency with the property?
      </Heading>
      <Grid className={FULLSTORY_EXCLUDE} display="grid" gridTemplateColumns="repeat(12, 1fr)" gap="xs">
        <Grid gridColumnEnd={{ default: 'span 12', sm_gte: 'span 6' }}>
          <FormField
            marginBottom="xs"
            label={<Label id="first-name">First name</Label>}
            control={
              <Input value={section.getFieldValue(EMERGENCY_CONTACT.FIELD_NAME.FIRST_NAME)} onChange={setFirstName} />
            }
          />
        </Grid>
        <Grid gridColumnEnd={{ default: 'span 12', sm_gte: 'span 6' }}>
          <FormField
            marginBottom="xs"
            label={<Label id="last-name">Last name</Label>}
            control={
              <Input value={section.getFieldValue(EMERGENCY_CONTACT.FIELD_NAME.LAST_NAME)} onChange={setLastName} />
            }
          />
        </Grid>
        <Grid gridColumnEnd="span 12">
          <FormField
            label={<Label>Phone number</Label>}
            control={
              <Input
                value={section.getFieldValue(EMERGENCY_CONTACT.FIELD_NAME.PHONE_NUMBER)}
                error={section
                  .getField(EMERGENCY_CONTACT.FIELD_NAME.PHONE_NUMBER)
                  .showOnError(PERSON.ERROR_MESSAGE.PHONE_NUMBER)}
                onChange={onPhoneNumberChange}
                type="tel"
              />
            }
            description={
              section
                .getField(EMERGENCY_CONTACT.FIELD_NAME.PHONE_NUMBER)
                .showOnError(PERSON.ERROR_MESSAGE.PHONE_NUMBER) && (
                <FormHelp error>
                  {section
                    .getField(EMERGENCY_CONTACT.FIELD_NAME.PHONE_NUMBER)
                    .showOnError(PERSON.ERROR_MESSAGE.PHONE_NUMBER)}
                </FormHelp>
              )
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
